export default "ligo compile storage exercise.jsligo \"{ name: \\\"3\\\", item_id: 2n, cost: 1n }\"\n# output is (Pair 1 2 \"3\")\n";